import {
  animate,
  style,
  query,
  keyframes,
  sequence,
  group,
  transition,
  state,
  AnimationStateMetadata,
  AnimationTransitionMetadata,
} from '@angular/animations';
import { styleVariables } from '../styles/variables';

export const pgCalendarTransitionBackdrop = [
  state(
    '*',
    style({
      opacity: 0.5,
    })
  ),
  transition(':enter', [
    style({
      opacity: 0,
    }),
    animate(
      `${styleVariables.transitionDurationShort}ms ${styleVariables.transitionCurveStandard}`,
      style({
        opacity: 0.5,
      })
    ),
  ]),
  transition(':leave', [
    style({
      opacity: 0.5,
    }),
    animate(
      `${styleVariables.transitionDurationShort}ms ${styleVariables.transitionCurveStandard}`,
      style({
        opacity: 0,
      })
    ),
  ]),
];
export const pgCalendarTransitionCalendar = [
  transition(
    ':enter',
    sequence([
      style({
        visibility: 'visible',
        transform: 'scale(.68,.72)',
      }),

      query(
        '.opacity-wrapper',
        [
          style({
            opacity: 0,
          }),
        ],
        { optional: true }
      ),

      group([
        animate(
          `${styleVariables.transitionDurationStandard}ms ${styleVariables.transitionCurveDeceleration}`,
          keyframes([
            style({
              transform: 'scale(.68,.72)',
            }),
            style({
              transform: 'scale(1,.84)',
            }),
            style({
              transform: 'scale(1,1)',
            }),
          ])
        ),
        query(
          '.opacity-wrapper',
          [
            animate(
              `${styleVariables.transitionDurationStandard}ms ${styleVariables.transitionCurveDeceleration}`,
              style({ opacity: 1 })
            ),
          ],
          { optional: true }
        ),
      ]),
    ])
  ),
  transition(
    ':leave',
    sequence([
      group([
        animate(
          `${styleVariables.transitionDurationShort}ms ${styleVariables.transitionCurveAcceleration}`,
          keyframes([
            style({
              transform: 'scale(1,1)',
            }),
            style({
              transform: 'scale(1,.84)',
            }),
            style({
              transform: 'scale(.68,.72)',
            }),
          ])
        ),
        query(
          '.opacity-wrapper',
          [
            style({ opacity: 1 }),
            animate(
              `${styleVariables.transitionDurationShort}ms ${styleVariables.transitionCurveAcceleration}`,
              style({ opacity: 0 })
            ),
          ],
          { optional: true }
        ),
      ]),
    ])
  ),
];
